export default __webpack_public_path__ + "static/media/clear_query.3542a6e0.png";